import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

export default function LegalPage({ i18nKey, testIdPrefix }) {
  const { t, tArray } = useI18n();
  const sections = tArray(`${i18nKey}.sections`);

  return (
    <article className="bg-white" data-testid={`${testIdPrefix}-page`}>
      <div className="max-w-4xl mx-auto px-5 md:px-8 py-16 md:py-24">
        <span className="text-xs uppercase tracking-[0.22em] text-[#0F5F3F]">
          {t(`${i18nKey}.updated`)}
        </span>
        <h1
          className="mt-3 font-serif text-4xl sm:text-5xl lg:text-6xl text-[#0E2A47] leading-tight"
          data-testid={`${testIdPrefix}-title`}
        >
          {t(`${i18nKey}.title`)}
        </h1>
        <p className="mt-6 text-base md:text-lg text-[#0E2A47]/80 leading-relaxed">
          {t(`${i18nKey}.intro`)}
        </p>
        <div className="mt-10 grid gap-8">
          {sections.map((s, idx) => (
            <section key={idx} data-testid={`${testIdPrefix}-section-${idx}`}>
              <h2 className="font-serif text-2xl text-[#0E2A47]">{s.title}</h2>
              <p className="mt-3 text-[#0E2A47]/80 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </article>
  );
}
